import React, { Component } from "react";
import "./LayoutItem.scss";
import { connect } from "react-redux";
import { setCurrentLayout } from "store/actions/layout";
import { SYSTEMS_PAGES } from "constants/pages.constant";
import { DupontTooltip } from "components/DupontTooltip";
import { getControlId } from "utils/utils";

class LayoutItem extends Component {
  constructor(props) {
    super(props);
    const { page, name } = this.props;
    this.state = {
      layoutID: `${getControlId(`${page} ${name}`)}`
    };
  }

  handleLayoutChange = () => {
    this.props.onSetCurrentLayout(this.props.page, this.props.layout);
    if (this.props.page === SYSTEMS_PAGES.DASHBOARDS) {
      this.props.setIsDashboardRerendering(true);
    } else if (this.props.page === SYSTEMS_PAGES.REPORTS) {
      this.props.setIsReportRerendering(true);
    }
  };

  editLayout = e => {
    e.stopPropagation();
    // Need to check, if it is required to set edit layout as current layout
    // this.props.onSetCurrentLayout(this.props.page, this.props.layout);
    this.props.onLayoutEdit(this.props.layout);
  };

  addWidget = e => {
    e.stopPropagation();
    this.props.onSetCurrentLayout(this.props.page, this.props.layout);
    this.props.setIsAddWidgetFormOpen(true);
  };

  getTooltip = e => {
    if (this.props.admin) {
      return this.props.user + "<br />" + this.props.userName;
    }
    return this.props.name;
  };

  render() {
    const selected = this.props.selected ? "layout-nav-option-selected" : null;
    return (
      <DupontTooltip
        title={
          this.props.admin ? (
            <>
              {this.props.userName} <br /> {this.props.user}
            </>
          ) : (
            this.props.name
          )
        }
        type="secondary"
      >
        <li className={`nav-layout-option ${selected}`} id={this.state.layoutID}>
          <div className="nav-layout-content" name="layout" onClick={this.handleLayoutChange}>
            <span>
              {this.props.admin && <div className={`bodyMainHeadingText pointer max-text-width`}>{this.props.userName}</div>}
              <div
                className={`${this.props.admin ? "descriptionText" : "bodyMainHeadingText overflow max-text-width"}`}
                dangerouslySetInnerHTML={{ __html: this.props.name }}
              ></div>
            </span>
            <div className="layoutIcons">
              <div className={this.props.home ? "homeDashboard" : null} type="button" />
            </div>
            {this.props.page !== SYSTEMS_PAGES.ANALYTICS && (
              <div className="layoutIconsOnHover">
                {this.props.page !== SYSTEMS_PAGES.CHARTS && (
                  <div
                    className={this.props.selected && !this.props.layout.DefaultDashboard ? "addWidgets" : null}
                    type="button"
                    onClick={this.addWidget}
                  />
                )}
                <div className="editLayout" type="button" onClick={this.editLayout} />
              </div>
            )}
          </div>
        </li>
      </DupontTooltip>
    );
  }
}

const mapStateToProps = ({ user }, ownProps) => {
  return { admin: user.isAdmin };
};

const mapDispatchToProps = dispatch => {
  return {
    onSetCurrentLayout: (label, layout) => dispatch(setCurrentLayout(label, layout))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutItem);
